// 店铺装修
import {

  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,
  WgtAbtest,

  WgtStickyLift,
  WgtTabsCut,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,

  WgtAroundStoreOne,
  WgtProductShelves,
  WgtContentPart,
  WgtLift,

  WgtCustomWgt,
  WgtImageText,
  WgtArticle,
  WgtMemberInfo,
  WgtSuspension,
  WgtUserContainer,
  WgtOfficialAccount,
  WgtNewMemberInfo,
  wgtDevices,
  WgtMemberTask
} from '../wgts/index'

export const initiWidgets = []

export const widgets = {

  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,
  WgtAbtest,

  WgtStickyLift,
  WgtTabsCut,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,

  WgtAroundStoreOne,
  WgtProductShelves,
  WgtContentPart,
  WgtLift,

  WgtCustomWgt,
  WgtImageText,
  WgtArticle,
  WgtMemberInfo,
  WgtSuspension,
  WgtUserContainer,
  WgtOfficialAccount,
  WgtNewMemberInfo,
  wgtDevices,
  WgtMemberTask
}


export default {
  widgets,
  initiWidgets
}
